import {
    convertUniversalDateToPersianDate,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoGridFourColumn,
    RaikoGridOneColumn,
    showErrorMessage,
    RaikoTableTitleContainer,
    RaikoSectionContainer,
    convertPersianDateToUniversalDate,
    convertCurrencyFormatPositiveNegative,
    convertUniversalDateTimeToPersianDateTime,
    showWarningMessage,
    RaikoToggleOutlined,
    RaikoDatePicker,
    RaikoGridThreeColumn,
    RaikoMoneyInputOutlined, RaikoButtonPrimary, showSuccessMessage,
    RaikoButtonSecondary, RaikoFlexFirstChildGrowOne, RaikoFlexAlignEnd
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAuthState} from "../../context/AuthContext";
import {GroupsService} from "../../serverService/groups/GroupsService";
import {LoanInstallmentsService} from "../../serverService/loanInstallments/LoanInstallmentsService";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import RaikoCardInfoTypeOne, {
    RaikoCardInfoTypeOneItemGenerator, RaikoCardInfoTypeOneStatusTypes
} from "../../raikoComponents/raikoCardInfo/RaikoCardInfoTypeOne";
import {RaikoErrorSection, RaikoLabel} from "@moeindal/base-raiko-panel-components"

export default function LoanPayInstallments() {

    const navigate = useNavigate()

    const {fundID} = useAuthState()
    const groupService = new GroupsService()
    const service = new LoanInstallmentsService()

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [groups, setGroups] = useState([]);
    const [month, setMonth] = useState([
        raikoCustomSelectItemGenerator(1, "فروردین"),
        raikoCustomSelectItemGenerator(2, "اردیبهشت"),
        raikoCustomSelectItemGenerator(3, "خرداد"),
        raikoCustomSelectItemGenerator(4, "تیر"),
        raikoCustomSelectItemGenerator(5, "مرداد"),
        raikoCustomSelectItemGenerator(6, "شهریور"),
        raikoCustomSelectItemGenerator(7, "مهر"),
        raikoCustomSelectItemGenerator(8, "آبان"),
        raikoCustomSelectItemGenerator(9, "آذر"),
        raikoCustomSelectItemGenerator(10, "دی"),
        raikoCustomSelectItemGenerator(11, "بهمن"),
        raikoCustomSelectItemGenerator(12, "اسفند"),
    ]);
    const [year, setYear] = useState([]);

    const [selectedGroups, setSelectedGroups] = useState(-1);
    const [selectedLoanIsTypeB, setSelectedLoanIsTypeB] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(1);
    const [selectedYear, setSelectedYear] = useState(-1);

    const [searchLoading, setSearchLoading] = useState(false);

    const [installments, setInstallments] = useState([]);

    const [summation, setSummation] = useState(0);


    useEffect(() => {
        setYear([])

        const date = new Date();
        const currentYear = convertUniversalDateToPersianDate(date.toISOString()).split("/")[0];


        const yearsArray = Array.from({length: currentYear - 1384}, (_, index) => currentYear - index)

        yearsArray.map((item) => {
            setYear(prev => [
                ...prev,
                raikoCustomSelectItemGenerator(item + 5, item + 5)
            ])
        })

        setSelectedYear(currentYear)

    }, [])

    useEffect(() => {
        getGroups()
    }, [fundID]);

    useEffect(() => {
        if (installments && installments.length > 0) {
            calculateSummationOfAmounts()
        }
    }, [installments]);

    function getGroups() {
        loading.show()
        groupService.getGroups(
            fundID,
            0,
            1000
        ).then(response => {
            setGroups([])
            response.data.map((item, index) => {
                setGroups(prev => [
                    ...prev,
                    raikoCustomSelectItemGenerator(item.id, item.name)
                ])
            })

            setSelectedGroups(response.data[0].id)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleGetInstallments() {
        setSearchLoading(true)
        service.getLoanInstallments(
            fundID,
            selectedGroups,
            convertPersianDateToUniversalDate(`${selectedYear}/${selectedMonth}/01`),
            selectedLoanIsTypeB
        ).then(response => {
            setInstallments([])

            if (response && response.length > 0) {
                response.map((item, index) => {
                    setInstallments(prev => [
                        ...prev, {
                            ...item,
                            paidAt: item.paidAt ? convertUniversalDateToPersianDate(item.paidAt) : ""
                        }
                    ])
                })
            } else
                showWarningMessage("هیچ اقساطی یافت نشد")


        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setSearchLoading(false)
        })
    }

    function calculateSummationOfAmounts() {
        setSummation(0)
        if (installments[0].includesMonthlyDeposit) {
            installments.map((item) => {
                if (item.checked) {
                    setSummation(prev => parseInt(prev) + parseInt(item.newAmountPaid) + parseInt(item.newMonthlyPaid))
                }
            })
        } else {
            installments.map((item) => {
                if (item.checked) {
                    setSummation(prev => parseInt(prev) + parseInt(item.newAmountPaid))
                }
            })
        }
    }

    function doPayInstallments() {
        /*
        *   paidAt
        *   newMonthlyPaid
        *   newAmountPaid
        * */

        const payList = []
        let hasError = false

        installments.map((item, index) => {
            if (item.checked) {

                if (item.paidAt && item.paidAt.length === 10) {
                    if (installments[0].includesMonthlyDeposit) {
                        payList.push({
                            id: item.id,
                            paidAt: convertPersianDateToUniversalDate(item.paidAt),
                            amount: item.newAmountPaid ? item.newAmountPaid : 0,
                            monthlyDepositAmount: item.newMonthlyPaid ? item.newMonthlyPaid : 0
                        })
                    } else {
                        payList.push({
                            id: item.id,
                            paidAt: convertPersianDateToUniversalDate(item.paidAt),
                            amount: item.newAmountPaid ? item.newAmountPaid : 0,
                        })
                    }
                } else if (!hasError) {
                    hasError = true
                    showWarningMessage("لطفا برای تمامی موارد فعال تاریخ ثبت را به درستی وارد نمایید!")
                }
            }
        })

        if (payList.length > 0) {
            loading.show()
            service.updateLoanInstallments(fundID, payList, installments[0].includesMonthlyDeposit)
                .then(response => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        } else
            showWarningMessage("هیچ اطلاعاتی برای ثبت وجود ندارد.")

    }


    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn className={css`gap: 1.5rem`}>

                <RaikoFlexFirstChildGrowOne>
                    <RaikoBreadcrumb className={css`flex-grow: 1;
                      gap: .5rem;`} breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.InstallmentsList.name,
                            RouteHelper.InstallmentsList.globalUrl
                        ),
                        raikoBreadCrumbItemGenerator(
                            "پرداخت اقساط",
                            ""
                        )
                    ]}/>

                    <RaikoButtonSecondary
                        label={"بازگشت"}
                        onClick={_ => {
                            navigate(-1);
                        }}
                    />
                </RaikoFlexFirstChildGrowOne>


                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoSectionContainer
                            title={"جستجو اقساط"}
                            subTitle={"برای بارگزاری اقساط اطلاعات مورد نیاز را وارد نمایید."}
                            hasActionButton
                            actionButtonTitle={"بارگزاری اقساط"}
                            actionButtonOnclick={handleGetInstallments}
                            actionButtonLoadingState={searchLoading}
                        >
                            <RaikoGridFourColumn>
                                <RaikoCustomSelect
                                    labelText={"گروه"}
                                    value={selectedGroups}
                                    setValue={setSelectedGroups}
                                    items={groups}/>

                                <RaikoCustomSelect
                                    labelText={"نوع قسط وام"}
                                    value={selectedLoanIsTypeB}
                                    setValue={setSelectedLoanIsTypeB}
                                    items={[
                                        raikoCustomSelectItemGenerator(false, "سایر اقساط"),
                                        raikoCustomSelectItemGenerator(true, "نوع B")
                                    ]}/>

                                <RaikoCustomSelect
                                    labelText={"ماه"}
                                    value={selectedMonth}
                                    setValue={setSelectedMonth}
                                    items={month}/>


                                <RaikoCustomSelect
                                    labelText={"سال"}
                                    value={selectedYear}
                                    setValue={setSelectedYear}
                                    items={year}/>

                            </RaikoGridFourColumn>
                        </RaikoSectionContainer>

                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"اقساط"}
                            amount={installments.length}
                        />
                        {
                            installments && installments.length > 0 ?
                                <RaikoGridOneColumn>
                                    {/* <RaikoAlert
                                        title={"در صورت فعال کردن گزینه 'ثبت کردن' و وارد نکردن اطلاعات پرداخت، اطلاعات پیشفرض به عنوان مقادیر پرداختی در هنگام بروزرسانی در نظر گرفته خواهند شد"}
                                        type={raikoAlertTypes.info}
                                        />*/}
                                    {
                                        installments[0].includesMonthlyDeposit ?
                                            installments.map((item, index) => {
                                                return <RaikoCardInfoTypeOne
                                                    key={`cardOne-${index}`}
                                                    title={item.id}
                                                    titleLabel={"شناسه قسط"}
                                                    statusType={item.paid ? RaikoCardInfoTypeOneStatusTypes.SUCCESS : RaikoCardInfoTypeOneStatusTypes.ERROR}
                                                    status
                                                    statusText={item.paid ? "پرداخت شده" : "پرداخت نشده"}
                                                    items={[
                                                        RaikoCardInfoTypeOneItemGenerator("نام و نام خانوادگی", `${item.firstName} ${item.lastName}`),
                                                        RaikoCardInfoTypeOneItemGenerator("کدملی", item.nationalCode),
                                                        RaikoCardInfoTypeOneItemGenerator("سررسید", convertUniversalDateTimeToPersianDateTime(item.dateOfPayment)),
                                                        RaikoCardInfoTypeOneItemGenerator("قابل پرداخت (ریال)", convertCurrencyFormatPositiveNegative(item.amountPayable)),
                                                        RaikoCardInfoTypeOneItemGenerator("پرداخت شده (ریال)", convertCurrencyFormatPositiveNegative(item.amountPaid)),
                                                        RaikoCardInfoTypeOneItemGenerator("باقی مانده وام (ریال)", convertCurrencyFormatPositiveNegative(item.remindAmountOfLoan)),
                                                        RaikoCardInfoTypeOneItemGenerator("واریز ماهانه قابل پرداخت (ریال)", convertCurrencyFormatPositiveNegative(item.monthlyDepositAmount)),
                                                        RaikoCardInfoTypeOneItemGenerator("نوع وام", item.loandKind),
                                                        RaikoCardInfoTypeOneItemGenerator("پرداخت کننده", item.paidByManger ? item.paidByManger : item.paidByMember ? item.paidByMember : "ندارد"),
                                                    ]}
                                                    hasBottomChildren
                                                >
                                                    <RaikoGridFourColumn>
                                                        <RaikoToggleOutlined
                                                            id={`status-${index}`}
                                                            checked={item.checked !== 'undefined' ? item.checked : false}
                                                            setChecked={enabled => {
                                                                let _installments = []

                                                                installments.map((_item, position) => {
                                                                    if (position !== index) {
                                                                        _installments.push(_item)
                                                                    } else {
                                                                        _installments.push(
                                                                            {
                                                                                ..._item,
                                                                                checked: enabled,

                                                                                paidAt: enabled ?
                                                                                    item.paidAt ?
                                                                                        item.paidAt : convertUniversalDateToPersianDate(item.dateOfPayment) : "",

                                                                                newMonthlyPaid: enabled ?
                                                                                    item.newMonthlyPaid || item.newMonthlyPaid === 0 || item.newMonthlyPaid !== undefined ?
                                                                                        item.newMonthlyPaid : item.amountPaidOfMonthlyDeposit ?
                                                                                            item.amountPaidOfMonthlyDeposit : item.monthlyDepositAmount : undefined,

                                                                                newAmountPaid: enabled ?
                                                                                    item.newAmountPaid || item.newAmountPaid === 0 || item.newAmountPaid !== undefined ?
                                                                                        item.newAmountPaid : item.amountPaidOfInstallment ?
                                                                                            item.amountPaidOfInstallment : item.amountPayable - item.monthlyDepositAmount : undefined
                                                                            }
                                                                        )
                                                                    }
                                                                })

                                                                setInstallments(_installments)

                                                            }}
                                                            labelText={"ثبت کردن"}
                                                        />
                                                        <RaikoDatePicker
                                                            label={"تاریخ پرداخت"}
                                                            date={item.paidAt}
                                                            setDate={date => {

                                                                let _installments = []

                                                                installments.map((_item, position) => {
                                                                    if (position !== index) {
                                                                        _installments.push(_item)
                                                                    } else {
                                                                        _installments.push(
                                                                            {
                                                                                ..._item,
                                                                                paidAt: date
                                                                            }
                                                                        )
                                                                    }
                                                                })

                                                                setInstallments(_installments)

                                                            }}
                                                        />

                                                        <RaikoMoneyInputOutlined
                                                            labelText={"واریز ماهانه (ریال)"}
                                                            value={
                                                                item.newMonthlyPaid ||
                                                                item.newMonthlyPaid === 0 ||
                                                                item.newMonthlyPaid !== undefined ? item.newMonthlyPaid
                                                                    : item.amountPaidOfMonthlyDeposit}
                                                            placeHolder={item.amountPaidOfMonthlyDeposit}
                                                            setValue={value => {
                                                                let _installments = []

                                                                installments.map((_item, position) => {
                                                                    if (position !== index) {
                                                                        _installments.push(_item)
                                                                    } else {
                                                                        _installments.push(
                                                                            {
                                                                                ..._item,
                                                                                newMonthlyPaid: value || value === 0 ? value : null
                                                                            }
                                                                        )
                                                                    }
                                                                })

                                                                setInstallments(_installments)
                                                            }}
                                                        />
                                                        <RaikoMoneyInputOutlined
                                                            labelText={"قسط وام و کمیسیون (ریال)"}
                                                            value={
                                                                item.newAmountPaid ||
                                                                item.newAmountPaid === 0 ||
                                                                item.newAmountPaid !== undefined
                                                                    ? item.newAmountPaid : item.amountPaidOfInstallment}
                                                            placeHolder={item.amountPayable}
                                                            setValue={value => {
                                                                let _installments = []

                                                                installments.map((_item, position) => {
                                                                    if (position !== index) {
                                                                        _installments.push(_item)
                                                                    } else {
                                                                        _installments.push(
                                                                            {
                                                                                ..._item,
                                                                                newAmountPaid: value || value === 0 ? value : null
                                                                            }
                                                                        )
                                                                    }
                                                                })

                                                                setInstallments(_installments)
                                                            }}
                                                        />
                                                    </RaikoGridFourColumn>
                                                </RaikoCardInfoTypeOne>
                                            }) :
                                            installments.map((item, index) => {
                                                return <RaikoCardInfoTypeOne
                                                    key={`cardOne-${index}`}
                                                    title={item.id}
                                                    titleLabel={"شناسه قسط"}
                                                    statusType={item.paid ? RaikoCardInfoTypeOneStatusTypes.SUCCESS : RaikoCardInfoTypeOneStatusTypes.ERROR}
                                                    status
                                                    statusText={item.paid ? "پرداخت شده" : "پرداخت نشده"}
                                                    items={[
                                                        RaikoCardInfoTypeOneItemGenerator("نام و نام خانوادگی", `${item.firstName} ${item.lastName}`),
                                                        RaikoCardInfoTypeOneItemGenerator("کدملی", item.nationalCode),
                                                        RaikoCardInfoTypeOneItemGenerator("سررسید", convertUniversalDateTimeToPersianDateTime(item.dateOfPayment)),
                                                        RaikoCardInfoTypeOneItemGenerator("قابل پرداخت (ریال)", convertCurrencyFormatPositiveNegative(item.amountPayable)),
                                                        RaikoCardInfoTypeOneItemGenerator("پرداخت شده (ریال)", convertCurrencyFormatPositiveNegative(item.amountPaid)),
                                                        RaikoCardInfoTypeOneItemGenerator("باقی مانده وام (ریال)", convertCurrencyFormatPositiveNegative(item.remindAmountOfLoan)),
                                                        RaikoCardInfoTypeOneItemGenerator("نوع وام", item.loandKind),
                                                        RaikoCardInfoTypeOneItemGenerator("پرداخت کننده", item.paidByManger ? item.paidByManger : item.paidByMember ? item.paidByMember : "ندارد"),
                                                    ]}
                                                    hasBottomChildren
                                                >
                                                    <RaikoGridThreeColumn>
                                                        <RaikoToggleOutlined
                                                            id={`status-${index}`}
                                                            checked={item.checked}
                                                            setChecked={enabled => {
                                                                let _installments = []

                                                                installments.map((_item, position) => {
                                                                    if (position !== index) {
                                                                        _installments.push(_item)
                                                                    } else {
                                                                        _installments.push(
                                                                            {
                                                                                ..._item,
                                                                                checked: enabled,
                                                                                paidAt: enabled ? item.paidAt ? item.paidAt : convertUniversalDateToPersianDate(item.dateOfPayment) : "",
                                                                                newAmountPaid: enabled ? item.newAmountPaid ? item.newAmountPaid : item.amountPaid ? item.amountPaid : item.amountPayable : null
                                                                            }
                                                                        )
                                                                    }
                                                                })

                                                                setInstallments(_installments)

                                                            }}
                                                            labelText={"ثبت کردن"}
                                                        />
                                                        <RaikoDatePicker
                                                            label={"تاریخ پرداخت"}
                                                            date={item.paidAt}
                                                            setDate={date => {

                                                                let _installments = []

                                                                installments.map((_item, position) => {
                                                                    if (position !== index) {
                                                                        _installments.push(_item)
                                                                    } else {
                                                                        _installments.push(
                                                                            {
                                                                                ..._item,
                                                                                paidAt: date
                                                                            }
                                                                        )
                                                                    }
                                                                })

                                                                setInstallments(_installments)

                                                            }}
                                                        />
                                                        <RaikoMoneyInputOutlined
                                                            labelText={"مبلغ پرداختی (ریال)"}
                                                            value={item.newAmountPaid || item.newAmountPaid === 0 ? item.newAmountPaid : item.amountPaid}
                                                            setValue={value => {
                                                                let _installments = []

                                                                installments.map((_item, position) => {
                                                                    if (position !== index) {
                                                                        _installments.push(_item)
                                                                    } else {
                                                                        _installments.push(
                                                                            {
                                                                                ..._item,
                                                                                newAmountPaid: value ? value : 0
                                                                            }
                                                                        )
                                                                    }
                                                                })

                                                                setInstallments(_installments)
                                                            }}
                                                        />
                                                    </RaikoGridThreeColumn>
                                                </RaikoCardInfoTypeOne>
                                            })
                                    }

                                    <RaikoFlexAlignEnd>
                                        <RaikoLabel
                                            className={css`flex-grow: 1;`}
                                            text={`مجموع (ریال) ${convertCurrencyFormatPositiveNegative(summation)}`}/>
                                        <RaikoButtonPrimary
                                            label={"پرداخت اقساط"}
                                            onClick={doPayInstallments}/>
                                    </RaikoFlexAlignEnd>
                                </RaikoGridOneColumn>
                                :
                                <RaikoErrorSection
                                    title={"هیچ اقساطی برای نمایش وجود ندارد"}
                                    subTitle={"برای نمایش اقساط فیلتر های مربوطه را تکمیل و بر روی '' بارگزاری اقساط '' کلیک نمایید."}

                                />
                        }
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}
